import React, { FunctionComponent } from 'react'
import styles from './style.module.css'
import { Message, MessageKinds } from '@afterpaytouch/core'
import { useCheckoutState, usePreferredCard } from '../../state'
import { TrackOnMount } from '../../integrations/monitoring'
import { TrackingEvent } from '../../model/monitoring'

interface NotificationProps {
  severe: boolean
  heading: string
  message: string
  kind?: MessageKinds
}

export const Notification: FunctionComponent<NotificationProps> = ({ severe, heading, message, kind = 'Info' }) => {
  const { card, reason } = usePreferredCard() ?? {}
  const { error } = useCheckoutState() ?? {}

  return (
    <div className={styles.container}>
      <Message kind={kind} iconName='Card' heading={heading} description={message} testNameSpace='notification' />
      {typeof error !== 'undefined' && <TrackOnMount eventName={TrackingEvent.VIEWED_NON_TERMINAL_ERROR} eventProperties={{ errorCode: error?.error }} />}
      {card !== null && reason !== null && <TrackOnMount eventName={TrackingEvent.VIEWED_NON_TERMINAL_ERROR} eventProperties={{ errorCode: reason, severe }} />}
    </div>
  )
}
